import { Box, MultiSelectField, NumberField } from '@medely/ui-kit';
import { Market } from '@mp/hooks';
import React from 'react';
import { useWatch } from 'react-hook-form';

type MarketsFormFieldsProps = {
  initialZipCode?: string | null;
  markets: Market[];
  onZipCodeChange: (value: string) => void;
};

export const MarketsFormFields = ({
  initialZipCode,
  markets,
  onZipCodeChange,
}: MarketsFormFieldsProps) => {
  const zipCode = useWatch({ name: 'zipCode' });

  if (zipCode?.length === 5) {
    onZipCodeChange(zipCode);
  }

  const isMarketZipCodePresent = (
    market: Pick<Market, 'market_locations'>,
  ): boolean | undefined => {
    return market.market_locations
      ?.flat()
      ?.map((market_location) => market_location.zip_code)
      ?.includes(initialZipCode || '');
  };

  const marketOptions = markets.map((market) => {
    return {
      value: market.id as number,
      label: market.display_name as string,
      disabled: isMarketZipCodePresent(market),
    };
  });

  return (
    <>
      <Box testId="markets-zip">
        <NumberField name="zipCode" label="Zip code" testId="markets-zip" maxDigits={5} />
      </Box>
      <Box pt={2}>
        <MultiSelectField
          options={marketOptions}
          name="market_ids"
          variant="list"
          label=""
          testId="markets-market-box"
        />
      </Box>
    </>
  );
};
